import type { PortalActionMenuItem } from "components/PortalActionMenu";
import { Badge } from "components/ui/Badge/Badge";
import {
  REPLY_STATUSES,
  type ReplyResponseStatus,
  replyStatusBadgeColor,
  replyStatusLabel,
} from "hooks/use-email-replies-api";
import { cn } from "lib/utils";
import { Check } from "lucide-react";

/**
 * ステータス変更用の PortalActionMenu アイテム配列を組み立てる.
 * 一覧 (三点リーダー) と詳細 (ヘッダ Dropdown) の両方で同一レイアウト
 * (チェック左 + Badge 右寄せ) を共有する.
 * @param {ReplyResponseStatus} current 現在のステータス
 * @param {Function} onPick ステータス選択時のハンドラ
 * @return {PortalActionMenuItem[]} メニュー項目配列
 */
export function buildStatusMenuItems(
  current: ReplyResponseStatus,
  onPick: (status: ReplyResponseStatus) => void,
): PortalActionMenuItem[] {
  return [
    { key: "title", type: "title", label: "ステータス変更" },
    ...REPLY_STATUSES.map<PortalActionMenuItem>(s => {
      const isCurrent = current === s;
      return {
        key: s,
        type: "button",
        label: (
          <span className="flex items-center gap-2 w-full">
            <Check
              size={12}
              className={cn(
                "text-base-content/60 shrink-0",
                !isCurrent && "invisible",
              )}
              aria-label={isCurrent ? "現在のステータス" : undefined}
            />
            <span className="ml-auto">
              <Badge color={replyStatusBadgeColor(s)} size="xs">
                {replyStatusLabel(s)}
              </Badge>
            </span>
          </span>
        ),
        onClick: () => onPick(s),
        isActive: isCurrent,
      };
    }),
  ];
}
